<template>
  <div id="app">
    <router-view></router-view>
    <!--07右侧客服导航-->
    <div class="right-bar  f-tac " v-if="config.KefuType == 0">
      <div class="bar-list-box">
        <div class="bar-list topbar-box bar-wechat">
          <a href=""
            ><i class="sideBar-animate"></i>扫码领课
            <div class="bar-list-cont">
              <p>
                <span ref="qrCodeUrl"></span><br />
                <span class="text-gry8a ">扫码免费领课</span>
              </p>
            </div>
          </a>
        </div>
        <div class="bar-list bar-app" @click="scroll(900)">
          <a href="javascript:">学习方案</a>
        </div>
        <div class="bar-list bar-phone" v-if="config.KefuTelList.length > 0">
          <a href="javascript:"
            >电话咨询
            <div class="bar-list-cont">
              <p v-for="(v, i) in config.KefuTelList" :key="i">
                <span>{{ v.KefuName }}：</span>{{ v.KefuNumber }}
              </p>
            </div>
          </a>
        </div>
        <div class="bar-list bar-qqq">
          <div>
            QQ咨询
            <div class="bar-list-cont">
              <p v-for="(v, i) in config.KefuQQList" :key="i">
                <a
                  target="_blank"
                  class="service_qq_a"
                  :href="
                    'http://wpa.qq.com/msgrd?v=3&uin=' +
                      v.KefuNumber +
                      '&site=qq&menu=yes'
                  "
                >
                  <img
                    src="https://img2.233.com/wx/union/pc/pupage/img/button_old_171.gif"
                  />
                  <span>{{ v.KefuName }}</span>
                </a>
              </p>
            </div>
          </div>
        </div>

        <div class="bar-list bar-app" v-if="config.HasApp">
          <a href=""
            >APP下载
            <div class="bar-list-cont">
              <p>
                <img src="/search/app/markappqrcode" /><br />
                <span class="text-gry8a ">手机听课更方便</span>
              </p>
            </div>
          </a>
        </div>
        <div class="bar-list bar-app" @click="scroll(99999)">
          <a href="javascript:">常见问题</a>
        </div>
      </div>
      <div @click="scroll(0)" class="bottombar-box bg-gry-f6">
        <i></i> <a href="javascript:">回到顶部</a>
      </div>
    </div>
    <!--07右侧客服导航 end-->
    <!----08常见问题---->
    <div class="questions_box">
      <div class="wx-mian" id="cjwt">
        <h2 class="title-h2"></h2>
        <ul class="questions-ul clearfix">
          <li>
            <div class="questions-bg">
              <font v-if="config.UActivityFlag">
                <h4>
                  <span class="questions-icon-06"></span>购买课程有什么优惠？
                </h4>
                <p>
                  <strong>新用户</strong
                  >：注册成功后48小时内，购课满200减20，满400减40，满600减60，满1200减150，满2400减350，满4800减580。<br />
                  <strong>老用户</strong>：累计购课满300，再次购课8折优惠。
                </p>
              </font>
              <font>
                <h4>
                  <span class="questions-icon-06"></span
                  >何时寄送书籍资料（教材/教辅）？
                </h4>
                <p>
                  <!-- <i class="red_wz">亲爱的学员，因过年期间快递停运，网校的纸质教材/教辅都将于2019年2月12日（大年初八）开始邮寄，对您造成的不便表示非常抱歉，祝各位学员新春快乐，万事如意！</i><br> -->
                  若您报名的班级包含赠送教材/教辅配套服务，有两种情况： <br />
                  <strong>情况1：教材和教辅资料已出版</strong><br />
                  默认购课7天后安排邮寄，若急需教材，请联系客服加急处理。<br />
                  <strong>情况2：教材和教辅资料未出版</strong><br />
                  教材上市后，根据购买课程的先后顺序安排邮寄；教辅《通关宝典》一般在考前1-2个月邮寄，具体请查看课程介绍。
                </p>
              </font>
            </div>
          </li>
          <li class="adfasf">
            <div class="questions-bg">
              <font>
                <h4><span class="questions-icon-06"></span>是否为新课程？</h4>
                <p>
                  您购买所有课程均为新版本，每年新教材上市或大纲修订，课程将及时更新。大纲/教材未出版前，赠送旧版课程方便用户提前复习，课程更新后可学习新版课程。
                </p>
              </font>
              <font>
                <h4>
                  <span class="questions-icon-06"></span>课程有效期是多久？
                </h4>
                <p>
                  网校所有课程都设置了有效期，考试项目不同有效期也不同，可查看课程旁有效期提醒。课程有效期是根据考试周期进行合理设定，部分班级含不过免费重学服务，具体请看课程介绍。
                </p>
              </font>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!----08常见问题END---->
    <!--09页尾-->
    <div id="footer" class="p-20" style="font:size:12px">
      <div class="w1000 f-tac fText">
        <p style="line-height:32px;">
          <a
            href="/search/app"
            target="_blank"
            style="margin-left:15px;margin-right:15px;"
            >{{ config.WebName }}APP</a
          >
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a
            href="/uc/down-course"
            target="_blank"
            style="margin-left:15px;margin-right:15px;"
            >讲义下载</a
          ><br />
        </p>
        <p style="line-height:32px;">
          <span>24小时报名咨询热线：</span
          ><b>{{ config.FooterContents.Tel }}</b>
          <span v-if="config.FooterContents.Address.length > 0"
            >&nbsp;&nbsp;地址：</span
          >{{ config.FooterContents.Address }}
        </p>
        <p
          style="line-height:32px;"
          v-if="
            config.FooterContents.QQ.length > 0 ||
              config.FooterContents.Email.length > 0
          "
        >
          <span>QQ：</span>{{ config.FooterContents.QQ }}
          <span>&nbsp;&nbsp;Email：</span>{{ config.FooterContents.Email }}
        </p>
        <p style="line-height:32px;">
          <span>{{ config.FooterContents.Copyright }}</span>
          <span>&nbsp;&nbsp;工业和信息化部备案号：</span>
          <a target="_blank" href="http://www.beian.miit.gov.cn">{{
            config.FooterContents.Putonrecord
          }}</a>
        </p>
        <div style="display: none;padding-top: 4px;text-align: center;">
          <!--<script type="text/javascript">var cnzz_protocol = (("https:" == document.location.protocol) ? " https://" : " http://");document.write(unescape("%3Cspan id='cnzz_stat_icon_1260097225'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s11.cnzz.com/z_stat.php%3Fid%3D1260097225%26online%3D1%26show%3Dline' type='text/javascript'%3E%3C/script%3E"));</script><span id="cnzz_stat_icon_1260097225"><a href="https://www.cnzz.com/stat/website.php?web_id=1260097225" target="_blank">站长统计</a><a href="https://www.cnzz.com/stat/website.php?web_id=1260097225" target="_blank"> |  今日IP[166] | 今日PV[1304] | 昨日IP[285] |  昨日PV[2988] | </a><a href="https://www.cnzz.com/stat/website.php?web_id=1260097225&amp;method=online" target="_blank">当前在线[17]</a></span><script src=" http://s11.cnzz.com/z_stat.php?id=1260097225&amp;online=1&amp;show=line" type="text/javascript"></script><script src="http://c.cnzz.com/core.php?web_id=1260097225&amp;show=line&amp;online=1&amp;t=z" charset="utf-8" type="text/javascript"></script>-->
        </div>
        <br />
      </div>
    </div>

    <!--09页尾 end-->
  </div>
</template>
<script>
import { getUnionConfig, Statistics } from "@/request/request.js";
import QRCode from "qrcodejs2";

export default {
  name: "App",
  components: {},
  data() {
    return {
      config: {},
    };
  },
  created() {
    if (
      sessionStorage.getItem(window.location.host + "puconfig") == undefined
    ) {
      getUnionConfig({}, (res) => {
        this.config = res.Result;
        sessionStorage.setItem(
          window.location.host + "puconfig",
          JSON.stringify(res.Result)
        );
        this.creatQrCode();
        if (this.config.IsSenior) {
          window.location.href = "/fine/category" + this.$route.path;
        }
        if (this.config.KefuType == 1) {
          var script = document.createElement("script");
          script.type = "text/javascript";
          try {
            script.appendChild(
              document.createTextNode(
                this.config.KefuCode.replace("<script>", "").replace(
                  /<\/script>/g,
                  ""
                )
              )
            );
          } catch (ex) {
            script.text = this.config.KefuCode;
          }
          document.body.appendChild(script);
        }
      });
    } else {
      this.config = JSON.parse(
        sessionStorage.getItem(window.location.host + "puconfig")
      );
      this.creatQrCode();
      if (this.config.IsSenior) {
        window.location.href = "/fine/category" + this.$route.path;
      }
      if (this.config.KefuType == 1) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        try {
          script.appendChild(
            document.createTextNode(
              this.config.KefuCode.replace("<script>", "").replace(
                /<\/script>/g,
                ""
              )
            )
          );
        } catch (ex) {
          script.text = this.config.KefuCode;
        }
        document.body.appendChild(script);
      }
    }
  },
  mounted() {
    this.initCnzz();
  },
  methods: {
    initCnzz() {
      Statistics({}, (res) => {
        const { Result } = res;
        window.setUnionCnzzConfig(Result);
      });
      const _script2 = document.createElement("script");
      _script2.type = "text/javascript";
      _script2.src =
        "https://v1.cnzz.com/z_stat.php?id=1279309440&web_id=1279309440";
      document.body.appendChild(_script2);
    },
    creatQrCode() {
      if (this.config.KefuType == 0) {
        setTimeout(() => {
          new QRCode(this.$refs.qrCodeUrl, {
            text: this.config.PromoteInfo, // 需要转换为二维码的内容
            width: 132,
            height: 132,
            colorDark: "#000",
            colorLight: "#fff",
          });
        }, 1000);
      }
    },
    scroll(num) {
      document.documentElement.scrollTop = num;
    },
  },
};
</script>
<style>
body {
  overflow-x: hidden;
}
</style>
